let DoipConstants$1 = class DoipConstants {

  static STATUS_OK = "0.DOIP/Status.001";
  static STATUS_BAD_REQUEST = "0.DOIP/Status.101";
  static STATUS_UNAUTHENTICATED = "0.DOIP/Status.102";
  static STATUS_FORBIDDEN = "0.DOIP/Status.103";
  static STATUS_NOT_FOUND = "0.DOIP/Status.104";
  static STATUS_CONFLICT = "0.DOIP/Status.105";
  static STATUS_DECLINED = "0.DOIP/Status.200";
  static STATUS_ERROR = "0.DOIP/Status.500";

  static OP_HELLO = "0.DOIP/Op.Hello";
  static OP_LIST_OPERATIONS = "0.DOIP/Op.ListOperations";
  static OP_CREATE = "0.DOIP/Op.Create";
  static OP_RETRIEVE = "0.DOIP/Op.Retrieve";
  static OP_UPDATE = "0.DOIP/Op.Update";
  static OP_DELETE = "0.DOIP/Op.Delete";
  static OP_SEARCH = "0.DOIP/Op.Search";

  static MESSAGE_ATT = "message";
};

class AuthenticationInfo {}

class PasswordAuthenticationInfo extends AuthenticationInfo {




  constructor(username, password) {
    super();
    this.username = username;
    this.password = password;
  }

  getAuthentication() {
    return this;
  }

  getClientId() {return undefined;}

  getUserKey() {return this.username;}
}

class InDoipSegment {






  constructor(isJson, value) {
    this.isJson = isJson;
    if (isJson) {
      this.blobValue = new Blob([JSON.stringify(value)]);
    } else if (value === null || value === undefined) {
      // the fetch API Body notion allows a null body to indicate an empty ReadableStream -- we use a non-null empty stream instead
      this.blobValue = new Blob([]);
    } else if (value instanceof ReadableStream) {
      this.readableStreamValue = value;
    } else if (value instanceof Blob) {
      this.blobValue = value;
    } else if (value instanceof ArrayBuffer) {
      this.blobValue = new Blob([value]);
    } else if (ArrayBuffer.isView(value)) {
      this.blobValue = new Blob([value]);
    } else if (typeof value === 'string') {
      this.blobValue = new Blob([value]);
    } else {
      throw new Error("Unexpected constructor parameters for InDoipSegment");
    }
    this.response = new Response(this.blobValue || this.readableStreamValue);
  }

  get body() {
    if (!this.readableStreamValue) this.readableStreamValue = this.response.body;
    return this.response.body;
  }

  get bodyUsed() {
    return this.response.bodyUsed;
  }

  async arrayBuffer() {
    return this.response.arrayBuffer();
  }

  async blob() {
    return this.response.blob();
  }

  async json() {
    return this.response.json();
  }

  async text() {
    return this.response.text();
  }

  async formData() {
    throw new TypeError('formData not supported');
  }

  /**
   * In situations where we can't just use ReadableStream -- namely, browsers which don't support ReadableStream requests in fetch --
   * we may want to know whether we had a ReadableStream or a Blob (in particular, a File) in order to construct a request
   * with the minimum of reading things into memory.
   */
  bytesAsProvided() {
    if (this.blobValue) return this.blobValue;
    return this.readableStreamValue;
  }

  close() {
    if (this.readableStreamValue) return this.readableStreamValue.cancel();
    return Promise.resolve();
  }
}

function getMessageFromErrorResponse(code, errorObject) {
  if (errorObject && typeof errorObject === 'object' && 'message' in errorObject && errorObject.message && typeof errorObject.message === 'string') {
    return errorObject.message;
  }
  return "DOIP Error: " + code;
}

class DoipError extends Error {



  constructor(code, response) {
    super(getMessageFromErrorResponse(code, response));
    this.code = code;
    this.response = response;
  }
}

const DEFAULT_CHUNK_SIZE = 8192;

class DelegatedCloseableReadableStreamUnderlyingSource {
  type = 'bytes';





  constructor(readableStream, closeFunction) {
    this.readableStream = readableStream;
    this.closeFunction = closeFunction;
  }

  setupReader() {
    try {
      this.reader = this.readableStream.getReader({ mode: 'byob' });
      this.isByteStream = true;
    } catch (e) {
      this.reader = this.readableStream.getReader();
      this.isByteStream = false;
    }
  }

  async start(controller) {
    try {
      this.setupReader();
      while (true) {
        let done;
        let value;
        let isTransferred;
        if (this.isByteStream) {
          if ('byobRequest' in controller && controller.byobRequest && controller.byobRequest.view) {
            ({ done } = await this.reader.read(controller.byobRequest.view));
            isTransferred = true;
          } else {
            const buffer = new ArrayBuffer(DEFAULT_CHUNK_SIZE);
            const view = new Uint8Array(buffer);
            ({ done, value } = await this.reader.read(view));
            isTransferred = false;
          }
        } else {
          ({ done, value } = await this.reader.read());
          isTransferred = false;
        }
        if (done) {
          controller.close();
          if ('byobRequest' in controller && controller.byobRequest) {
            controller.byobRequest.respond(0);
          }
          await this.closeFunction();
          return;
        }
        if (isTransferred) continue;
        if ('byobRequest' in controller && controller.byobRequest && controller.byobRequest.view) {
          this.performByobTransfer(value, controller);
        } else {
          controller.enqueue(value);
        }
      }
    } catch (e) {
      await this.cancel(e);
    }
  }

  performByobTransfer(value, controller) {
    const len = Math.min(value.byteLength, controller.byobRequest.view.byteLength);
    let valueToSet = value;
    if (len < value.byteLength) {
      valueToSet = value.subarray(0, len);
    }
    let viewToSetInto = controller.byobRequest.view;
    if (!(viewToSetInto instanceof Uint8Array)) {
      viewToSetInto = new Uint8Array(viewToSetInto.buffer, viewToSetInto.byteOffset, viewToSetInto.byteLength);
    }
    viewToSetInto.set(valueToSet);
    controller.byobRequest.respond(len);
    if (len < value.byteLength) {
      const valueToEnqueue = value.subarray(len);
      controller.enqueue(valueToEnqueue);
    }
  }

  async cancel(reason) {
    try {
      if (this.reader) {
        await this.reader.cancel(reason);
      } else {
        await this.readableStream.cancel(reason);
      }
    } finally {
      await this.closeFunction();
    }
  }
}

class DelegatedCloseableReadableStream extends ReadableStream {
  constructor(readableStream, closeFunction) {
    super(new DelegatedCloseableReadableStreamUnderlyingSource(readableStream, closeFunction));
  }
}

let InDoipMessageFromIterable$1 = class InDoipMessageFromIterable {



  constructor(iterable) {
    this.iterator = iterable[Symbol.iterator]();
  }

  [Symbol.asyncIterator]() {
    return this;
  }

  async next() {
    if (this.done) return { done: true, value: undefined };
    return this.iterator.next();
  }

  async close() {
    if (this.iterator.return) this.iterator.return();
    this.done = true;
  }
};

class DigitalElementWithBody {






  constructor(digitalElement) {
    this.id = digitalElement.id;
    this.type = digitalElement.type;
    this.length = digitalElement.length;
    this.attributes = digitalElement.attributes;
    if (digitalElement instanceof DigitalElementWithBody) {
      this.bodySegment = new InDoipSegment(false, digitalElement.bytesAsProvided());
    } else {
      this.bodySegment = new InDoipSegment(false, digitalElement.body);
    }
  }

  get body() {
    return this.bodySegment.body;
  }

  get bodyUsed() {
    return this.bodySegment.bodyUsed;
  }

  async arrayBuffer() {
    return this.bodySegment.arrayBuffer();
  }

  async blob() {
    return this.bodySegment.blob();
  }

  async json() {
    return this.bodySegment.json();
  }

  async text() {
    return this.bodySegment.text();
  }

  async formData() {
    throw new TypeError('formData not supported');
  }

  /**
   * In situations where we can't just use ReadableStream -- namely, browsers which don't support ReadableStream requests in fetch --
   * we may want to know whether we had a ReadableStream or a Blob (in particular, a File) in order to construct a request
   * with the minimum of reading things into memory.
   */
  bytesAsProvided() {
    if (!this.bodySegment) throw new Error('No body for this DigitalElement');
    return this.bodySegment.bytesAsProvided();
  }
}

// TODO


class AbstractDoipClient {

  static REQUEST_ID_LENGTH = 32;
  static REQUEST_ID_CHARS = '0123456789ABCDEF';









  async performCompactOperationJsonResponse(doipRequest, serviceInfo, requestOptions) {
    let doipResponse;
    try {
      doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessage = doipResponse.getOutput();
        const firstSegment = await AbstractDoipClient.getFirstSegment(inDoipMessage);
        if (firstSegment == null) {
          throw new Error("Missing first segment in response");
        }
        return await firstSegment.json();
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async hello(authInfo, serviceInfo, requestOptions) {
    let doipResponse;
    try {
      const doipRequest = {
        targetId: serviceInfo?.serviceId || 'service',
        operationId: DoipConstants$1.OP_HELLO,
        authentication: authInfo
      };
      doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessage = doipResponse.getOutput();
        const resultDobj = await this.digitalObjectFromSegments(inDoipMessage);
        return resultDobj;
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async retrieve(targetId, authInfo, serviceInfo, includeElementData, requestOptions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attributes = {};
    if (includeElementData) {
      attributes.includeElementData = "true";
    }
    let doipResponse;
    try {
      const doipRequest = {
        targetId,
        operationId: DoipConstants$1.OP_RETRIEVE,
        authentication: authInfo,
        attributes
      };
      doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessage = doipResponse.getOutput();
        const resultDobj = await this.digitalObjectFromSegments(inDoipMessage);
        return resultDobj;
      } else if (doipResponse.getStatus() === DoipConstants$1.STATUS_NOT_FOUND) {
        return null;
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async listOperations(targetId, authInfo, serviceInfo, requestOptions) {
    const doipRequest = {
      targetId,
      operationId: DoipConstants$1.OP_LIST_OPERATIONS,
      authentication: authInfo
    };
    return this.performCompactOperationJsonResponse(doipRequest, serviceInfo, requestOptions);
  }

  async searchIds(query, params, authInfo, serviceInfo, requestOptions) {
    return this.searchIdsOrFull("id", query, params, authInfo, serviceInfo, requestOptions);
  }

  async search(query, params, authInfo, serviceInfo, requestOptions) {
    return this.searchIdsOrFull("full", query, params, authInfo, serviceInfo, requestOptions);
  }

  async searchIdsOrFull(type, query, params, authInfo, serviceInfo, requestOptions) {
    const attributes = { ...params, query, type };
    const doipRequest = {
      targetId: serviceInfo?.serviceId || 'service',
      operationId: DoipConstants$1.OP_SEARCH,
      authentication: authInfo,
      attributes
    };
    return this.performCompactOperationJsonResponse(doipRequest, serviceInfo, requestOptions);
  }

  // Robert 2023-10-10 I believe stringification of the sort fields is no longer necessary
  // static getSortFieldsAsString(sortFields: SortField[]): string | null {
  //     if (sortFields && sortFields.length !== 0) {
  //         const sortFieldsForTransport = [];
  //         for (const sortField of sortFields) {
  //             if (sortField.reverse) sortFieldsForTransport.push(sortField.name + " DESC");
  //             else sortFieldsForTransport.push(sortField.name);
  //         }
  //         if (sortFieldsForTransport.length > 0) {
  //             return sortFieldsForTransport.join(",");
  //         }
  //     }
  //     return null;
  // }

  async delete(targetId, authInfo, serviceInfo, requestOptions) {
    let doipResponse;
    try {
      const doipRequest = {
        targetId,
        operationId: DoipConstants$1.OP_DELETE,
        authentication: authInfo
      };
      doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      if (doipResponse.getStatus() !== DoipConstants$1.STATUS_OK) {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async retrieveElement(targetId, elementId, authInfo, serviceInfo, requestOptions) {
    const attributes = {
      element: elementId
    };
    return this.retrieveElementViaAttributes(targetId, attributes, authInfo, serviceInfo, requestOptions);
  }

  async retrievePartialElement(targetId, elementId, start, end, authInfo, serviceInfo, requestOptions) {
    const attributes = {
      element: elementId,
      range: {
        start,
        end
      }
    };
    return this.retrieveElementViaAttributes(targetId, attributes, authInfo, serviceInfo, requestOptions);
  }

  async retrieveElementViaAttributes(targetId, attributes, authInfo, serviceInfo, requestOptions) {
    let doipResponse;
    let callerWillClose = false;
    try {
      const doipRequest = {
        targetId,
        operationId: DoipConstants$1.OP_RETRIEVE,
        authentication: authInfo,
        attributes
      };
      doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessage = doipResponse.getOutput();
        const firstSegment = await AbstractDoipClient.getFirstSegment(inDoipMessage);
        if (firstSegment == null) {
          throw new Error("Missing first segment in response");
        }
        if (firstSegment.isJson) {
          return firstSegment;
        }
        const bytes = firstSegment.bytesAsProvided();
        if (bytes instanceof ReadableStream) {
          callerWillClose = true;
          return new InDoipSegment(false, new DelegatedCloseableReadableStream(bytes, async () => {
            await doipResponse.close();
          }));
        } else {
          return firstSegment;
        }
      } else if (doipResponse.getStatus() === DoipConstants$1.STATUS_NOT_FOUND) {
        return null;
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse && !callerWillClose) {
        await doipResponse.close();
      }
    }
  }

  async create(digitalObject, suffix, authInfo, serviceInfo, requestOptions) {
    const targetId = serviceInfo?.serviceId || 'service';
    const doipRequest = {
      targetId,
      operationId: DoipConstants$1.OP_CREATE,
      authentication: authInfo
    };
    if (suffix) {
      doipRequest.attributes = {
        suffix
      };
    }
    let doipResponse;
    try {
      if (this.hasElementStreamsOrBytes(digitalObject)) {
        const inDoipMessage = this.buildCreateOrUpdateMessageFrom(digitalObject, false);
        doipRequest.input = inDoipMessage;
        doipResponse = await this.performOperation(doipRequest, serviceInfo, requestOptions);
      } else {
        const dobjClone = this.shallowCopyDigitalObjectMinusElementBytes(digitalObject);
        doipRequest.inputJson = dobjClone;
        doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      }
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessageResponse = doipResponse.getOutput();
        const resultDobj = await this.digitalObjectFromSegments(inDoipMessageResponse);
        return resultDobj;
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async update(digitalObject, authInfo, serviceInfo, elementsToDelete, requestOptions) {
    const targetId = digitalObject.id;
    const attributes = {};
    if (elementsToDelete) {
      attributes.elementsToDelete = elementsToDelete;
    }
    const doipRequest = {
      targetId,
      operationId: DoipConstants$1.OP_UPDATE,
      authentication: authInfo,
      attributes
    };
    let doipResponse;
    try {
      if (this.hasElementStreamsOrBytes(digitalObject)) {
        const inDoipMessage = this.buildCreateOrUpdateMessageFrom(digitalObject, true);
        doipRequest.input = inDoipMessage;
        doipResponse = await this.performOperation(doipRequest, serviceInfo, requestOptions);
      } else {
        const dobjClone = this.shallowCopyDigitalObjectMinusElementBytes(digitalObject);
        doipRequest.inputJson = dobjClone;
        doipResponse = await this.performCompactOperation(doipRequest, serviceInfo, requestOptions);
      }
      if (doipResponse.getStatus() === DoipConstants$1.STATUS_OK) {
        const inDoipMessageResponse = doipResponse.getOutput();
        const resultDobj = await this.digitalObjectFromSegments(inDoipMessageResponse);
        return resultDobj;
      } else {
        throw await AbstractDoipClient.doipExceptionFromDoipResponse(doipResponse);
      }
    } finally {
      if (doipResponse) {
        await doipResponse.close();
      }
    }
  }

  async introspectToken(token, attributes, serviceInfo, requestOptions) {
    const doipRequest = {
      targetId: serviceInfo?.serviceId || 'service',
      operationId: '20.DOIP/Op.Auth.Introspect',
      attributes,
      inputJson: { token }
    };
    return this.performCompactOperationJsonResponse(doipRequest, serviceInfo, requestOptions);
  }

  async checkCredentials(doipRequest, serviceInfo, requestOptions) {
    const doipRequestToSend = {
      ...doipRequest,
      targetId: serviceInfo?.serviceId || 'service',
      operationId: '20.DOIP/Op.CheckCredentials'
    };
    return this.performCompactOperationJsonResponse(doipRequestToSend, serviceInfo, requestOptions);
  }

  hasElementStreamsOrBytes(digitalObject) {
    if (digitalObject.elements) {
      for (const el of digitalObject.elements) {
        if (el.body) return true;
      }
    }
    return false;
  }

  buildCreateOrUpdateMessageFrom(dobj, isUpdate) {
    const segments = [];
    const dobjClone = this.shallowCopyDigitalObjectMinusElementBytes(dobj);
    const dobjSegment = new InDoipSegment(true, dobjClone);
    segments.push(dobjSegment);
    if (dobj.elements) {
      for (const el of dobj.elements) {
        if (isUpdate && el.body === undefined) continue; //TODO test update stream
        const elementSegmentJson = { id: el.id };
        const elementHeaderSegment = new InDoipSegment(true, elementSegmentJson);
        segments.push(elementHeaderSegment);
        let bytesSegment;
        if (el.body === undefined) {
          throw new Error('DigitalElement without bytes used for create or update');
        } else if (el instanceof DigitalElementWithBody) {
          bytesSegment = new InDoipSegment(false, el.bytesAsProvided());
        } else {
          bytesSegment = new InDoipSegment(false, el.body);
        }
        segments.push(bytesSegment);
      }
    }
    return new InDoipMessageFromIterable$1(segments);
  }

  shallowCopyDigitalObjectMinusElementBytes(dobj) {
    const clone = {};
    clone.id = dobj.id;
    clone.type = dobj.type;
    clone.attributes = dobj.attributes;
    if (dobj.elements) {
      clone.elements = [];
      for (const el of dobj.elements) {
        const cloneEl = {
          id: el.id,
          type: el.type,
          length: el.length,
          attributes: el.attributes
        };
        clone.elements.push(cloneEl);
      }
    }
    return clone;
  }

  async digitalObjectFromSegments(inDoipMessage) {
    const firstSegment = await AbstractDoipClient.getFirstSegment(inDoipMessage);
    if (firstSegment == null) {
      throw new Error("Missing input");
    }
    const digitalObject = {};
    Object.assign(digitalObject, await firstSegment.json());
    if (digitalObject.elements) {
      const elements = {};
      for (const el of digitalObject.elements) {
        elements[el.id] = el;
      }
      let elementId = null;
      for await (const segment of inDoipMessage) {
        if (elementId === null) {
          if (segment.isJson) {
            const json = await segment.json();
            if (json && typeof json === 'object' && 'id' in json) {
              elementId = json.id;
              if (typeof elementId === 'string') continue;
            }
          }
          throw new Error("Expected element header");
        } else {
          const elementBytesSegment = segment;
          const el = elements[elementId];
          if (!el) {
            throw new Error("No such element " + elementId);
          }
          elements[el.id] = new DigitalElementWithBody({ ...el, body: elementBytesSegment.bytesAsProvided() });
          elementId = null;
        }
      }
      if (elementId !== null) {
        //Should have ended with a bytes segment
        throw new Error("Unexpected end of input");
      }
      digitalObject.elements = Object.values(elements);
    } else if (!(await this.isEmpty(inDoipMessage))) {
      throw new Error("Unexpected input segments");
    }
    return digitalObject;
  }

  async isEmpty(inDoipMessage) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for await (const segment of inDoipMessage) {
      return false;
    }
    return true;
  }

  static async getFirstSegment(inDoipMessage) {
    for await (const segment of inDoipMessage) {
      return segment;
    }
    return null;
  }

  static async doipExceptionFromDoipResponse(doipResponse) {
    const output = doipResponse.getOutput();
    let responseJson;
    if (output) {
      const firstSegment = await AbstractDoipClient.getFirstSegment(output);
      if (firstSegment && firstSegment.isJson) {
        responseJson = await firstSegment.json();
      }
    }
    const e = new DoipError(doipResponse.getStatus(), responseJson);
    return e;
  }

  async headersFrom(doipRequest) {
    const doipRequestHeaders = {};
    if (!doipRequest.requestId) {
      doipRequestHeaders.requestId = AbstractDoipClient.generateRequestId();
    } else {
      doipRequestHeaders.requestId = doipRequest.requestId;
    }
    doipRequestHeaders.targetId = doipRequest.targetId;
    doipRequestHeaders.operationId = doipRequest.operationId;
    doipRequestHeaders.clientId = doipRequest.clientId;
    if (doipRequest.authentication instanceof AuthenticationInfo) {
      if (!doipRequest.clientId) doipRequestHeaders.clientId = doipRequest.authentication.getClientId();
      doipRequestHeaders.authentication = await doipRequest.authentication.getAuthentication();
      if (doipRequest.authentication instanceof PasswordAuthenticationInfo) {
        doipRequestHeaders.clientId = undefined;
      }
    } else if (doipRequest.authentication) {
      doipRequestHeaders.authentication = doipRequest.authentication;
    }
    if (doipRequest.attributes) {
      doipRequestHeaders.attributes = doipRequest.attributes;
    } else {
      doipRequestHeaders.attributes = {};
    }
    if (doipRequest.inputJson != null) {
      doipRequestHeaders.input = doipRequest.inputJson;
    }
    return doipRequestHeaders;
  }

  static generateRequestId() {
    let result = '';
    for (let i = AbstractDoipClient.REQUEST_ID_LENGTH; i > 0; i--) {
      result += AbstractDoipClient.REQUEST_ID_CHARS[Math.floor(Math.random() * AbstractDoipClient.REQUEST_ID_CHARS.length)];
    }
    return result;
  }


}

class DoipConstants {

  static STATUS_OK = "0.DOIP/Status.001";
  static STATUS_BAD_REQUEST = "0.DOIP/Status.101";
  static STATUS_UNAUTHENTICATED = "0.DOIP/Status.102";
  static STATUS_FORBIDDEN = "0.DOIP/Status.103";
  static STATUS_NOT_FOUND = "0.DOIP/Status.104";
  static STATUS_CONFLICT = "0.DOIP/Status.105";
  static STATUS_DECLINED = "0.DOIP/Status.200";
  static STATUS_ERROR = "0.DOIP/Status.500";

  static OP_HELLO = "0.DOIP/Op.Hello";
  static OP_LIST_OPERATIONS = "0.DOIP/Op.ListOperations";
  static OP_CREATE = "0.DOIP/Op.Create";
  static OP_RETRIEVE = "0.DOIP/Op.Retrieve";
  static OP_UPDATE = "0.DOIP/Op.Update";
  static OP_DELETE = "0.DOIP/Op.Delete";
  static OP_SEARCH = "0.DOIP/Op.Search";

  static MESSAGE_ATT = "message";
}

const webcrypto = globalThis.crypto;

const Base64 = { decode: decode$2, encode: encode$2, encodeUrlSafe };

const un$1 = undefined;

const base64DecodeArray = [
un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1,
un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1,
un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, un$1, 62, un$1, 62, un$1, 63,
52, 53, 54, 55, 56, 57, 58, 59, 60, 61, un$1, un$1, un$1, un$1, un$1, un$1,
// eslint-disable-next-line no-multi-spaces
un$1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, un$1, un$1, un$1, un$1, 63,
un$1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];


const base64EncodeArray = [
'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f',
'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '/'];


const base64UrlEncodeArray = [
'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f',
'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '_'];


function decode$2(s) {
  const res = new Uint8Array(calcNumBytes$2(s));
  let pos = 0;
  let inFour = 0;
  let accum = 0;
  for (let i = 0; i < s.length; i++) {
    const code = base64DecodeArray[s.charCodeAt(i)];
    if (code === undefined) continue;
    if (inFour === 0) {
      accum = code << 2;
    } else if (inFour === 1) {
      accum |= code >>> 4;
      res[pos++] = accum;
      accum = (code & 0x0F) << 4;
    } else if (inFour === 2) {
      accum |= code >>> 2;
      res[pos++] = accum;
      accum = (code & 0x03) << 6;
    } else {
      accum |= code;
      res[pos++] = accum;
    }
    inFour = (inFour + 1) % 4;
  }
  return res.subarray(0, pos);
}

function calcNumBytes$2(str) {
  let len = str.length;
  if (str[str.length - 1] === '=') {
    len -= 1;
    if (str[str.length - 2] === '=') len -= 1;
  }
  const mod = len % 4;
  if (mod === 0) return 3 * len / 4;
  if (mod === 1) return 3 * (len - 1) / 4;
  if (mod === 2) return 3 * (len - 2) / 4 + 1;
  return 3 * (len - 3) / 4 + 2;
}

function genericBase64EncoderFunction(arr, thisBase64EncodeArray, usePad) {
  let s = '';
  let accum = 0;
  let inThree = 0;
  for (let i = 0; i < arr.length; i++) {
    const code = arr[i];
    if (inThree === 0) {
      s += thisBase64EncodeArray[code >>> 2];
      accum = (code & 0x03) << 4;
    } else if (inThree === 1) {
      accum |= code >>> 4;
      s += thisBase64EncodeArray[accum];
      accum = (code & 0x0F) << 2;
    } else {
      accum |= code >>> 6;
      s += thisBase64EncodeArray[accum];
      s += thisBase64EncodeArray[code & 0x3F];
    }
    inThree = (inThree + 1) % 3;
  }
  if (inThree > 0) {
    s += thisBase64EncodeArray[accum];
    if (usePad) {
      const pad = '=';
      s += pad;
      if (inThree === 1) s += pad;
    }
  }
  return s;
}

function encode$2(arr) {
  return genericBase64EncoderFunction(arr, base64EncodeArray, true);
}

function encodeUrlSafe(arr) {
  return genericBase64EncoderFunction(arr, base64UrlEncodeArray, false);
}

const Utf8 = { decode: decode$1, encode: encode$1, looksLikeBinary, stringLooksLikeBinary };

function decode$1(str) {
  const res = new Uint8Array(calcNumBytes$1(str));
  let pos = 0;
  for (let i = 0; i < str.length; i++) {
    let code = str.charCodeAt(i);
    if (code <= 0x7F) {
      res[pos++] = code;
    } else if (code <= 0x7FF) {
      res[pos++] = 0xC0 | code >>> 6;
      res[pos++] = 0x80 | code & 0x3F;
    } else if (0xD800 <= code && code <= 0xDBFF) {
      if (i + 1 < str.length) {
        const next = str.charCodeAt(i + 1);
        if (0xDC00 <= next && next <= 0xDFFF) {
          i++;
          code = ((code - 0xD800) * 0x400 | next - 0xDC00) + 0x10000;
          res[pos++] = 0xF0 | code >>> 18;
          res[pos++] = 0x80 | code >>> 12 & 0x3F;
          res[pos++] = 0x80 | code >>> 6 & 0x3F;
          res[pos++] = 0x80 | code & 0x3F;
          continue;
        }
      }
      // bare surrogate
      res[pos++] = 0xE0 | code >>> 12;
      res[pos++] = 0x80 | code >>> 6 & 0x3F;
      res[pos++] = 0x80 | code & 0x3F;
    } else {
      res[pos++] = 0xE0 | code >>> 12;
      res[pos++] = 0x80 | code >>> 6 & 0x3F;
      res[pos++] = 0x80 | code & 0x3F;
    }
  }
  return res;
}

function calcNumBytes$1(str) {
  let res = 0;
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code <= 0x7F) res += 1;else
    if (code <= 0x7FF) res += 2;else
    if (0xD800 <= code && code <= 0xDBFF) {
      if (i + 1 < str.length) {
        const next = str.charCodeAt(i + 1);
        if (0xDC00 <= next && next <= 0xDFFF) {
          i++;
          res += 4;
          continue;
        }
      }
      // bare surrogate
      res += 3;
    } else res += 3;
  }
  return res;
}

function encode$1(arr) {
  let str = '';
  for (let i = 0; i < arr.length; i++) {
    let code = arr[i];
    let thisValid = false;
    if (code <= 0x7F) {
      thisValid = true;
      //            if(!binary && (code <= 0x08 || (0x0E <= code && code < 0x20) || code===0x7F)) binary = true;
      str += String.fromCharCode(code);
    } else if (code <= 0xC1 || code >= 0xF5) {
      thisValid = false;
    } else if (code <= 0xDF) {
      if (i + 1 < arr.length) {
        const c2 = arr[i + 1];
        if (0x80 <= c2 && c2 <= 0xBF) {
          thisValid = true;
          i++;
          str += String.fromCharCode((code & 0x1F) << 6 | c2 & 0x3F);
        }
      }
    } else if (code <= 0xEF) {
      if (i + 2 < arr.length) {
        const c2 = arr[i + 1];
        const c3 = arr[i + 2];
        if (0x80 <= c2 && c2 <= 0xBF && 0x80 <= c3 && c3 <= 0xBF && !(code === 0xE0 && c2 <= 0x9F)) {
          thisValid = true;
          i += 2;
          str += String.fromCharCode((code & 0x0F) << 12 | (c2 & 0x3F) << 6 | c3 & 0x3F);
        }
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (i + 3 < arr.length) {
        const c2 = arr[i + 1];
        const c3 = arr[i + 2];
        const c4 = arr[i + 3];
        if (0x80 <= c2 && c2 <= 0xBF && 0x80 <= c3 && c3 <= 0xBF && 0x80 <= c4 && c4 <= 0xBF && !(code === 0xF0 && c2 <= 0x8F)) {
          code = (code & 0x07) << 18 | (c2 & 0x3F) << 12 | (c3 & 0x3F) << 6 | c4 & 0x3F;
          if (code <= 0x10FFFF) {
            thisValid = true;
            i += 3;
            code -= 0x10000;
            str += String.fromCharCode(0xD800 + (code >> 10), 0xDC00 + (code & 0x3FF));
          }
        }
      }
    }
    if (!thisValid) {
      str += String.fromCharCode(0xFFFD);
    }
  }
  return str;
}

function looksLikeBinary(arr) {
  for (let i = 0; i < arr.length; i++) {
    const code = arr[i];
    if (code <= 0x7F) {
      if (code <= 0x08 || 0x0E <= code && code < 0x20 || code === 0x7F) return true;
    } else if (code <= 0xC1 || code >= 0xF5) {
      return true;
    } else if (code <= 0xDF) {
      if (i + 1 >= arr.length) return true;
      const c2 = arr[++i];
      if (!(0x80 <= c2 && c2 <= 0xBF)) return true;
    } else if (code <= 0xEF) {
      if (i + 2 >= arr.length) return true;
      const c2 = arr[++i];
      const c3 = arr[++i];
      if (!(0x80 <= c2 && c2 <= 0xBF && 0x80 <= c3 && c3 <= 0xBF && !(code === 0xE0 && c2 <= 0x9F))) return true;
    } else {
      if (i + 3 >= arr.length) return true;
      const c2 = arr[++i];
      const c3 = arr[++i];
      const c4 = arr[++i];
      if (!(0x80 <= c2 && c2 <= 0xBF && 0x80 <= c3 && c3 <= 0xBF && 0x80 <= c4 && c4 <= 0xBF && !(code === 0xF0 && c2 <= 0x8F))) return true;
    }
  }
  return false;
}

function stringLooksLikeBinary(str) {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code <= 0x08 || 0x0E <= code && code < 0x20 || code === 0x7F || code === 0xFFFD) return true;
  }
  return false;
}

const Hex = { decode, encode };

const un = undefined;

const hexDecodeArray = [
un, un, un, un, un, un, un, un, un, un, un, un, un, un, un, un,
un, un, un, un, un, un, un, un, un, un, un, un, un, un, un, un,
un, un, un, un, un, un, un, un, un, un, un, un, un, un, un, un,
// eslint-disable-next-line no-multi-spaces
0, 1, 2, 3, 4, 5, 6, 7, 8, 9, un, un, un, un, un, un,
un, 10, 11, 12, 13, 14, 15, 16, un, un, un, un, un, un, un, un,
un, un, un, un, un, un, un, un, un, un, un, un, un, un, un, un,
un, 10, 11, 12, 13, 14, 15, 16];


const hexEncodeArray = [
'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];


function decode(str) {
  if (str.length % 2 !== 0) str = "0" + str;
  const res = new Uint8Array(calcNumBytes(str));
  let pos = 0;
  let inTwo = 0;
  let accum = 0;
  for (let i = 0; i < str.length; i++) {
    const code = hexDecodeArray[str.charCodeAt(i)];
    if (code === undefined) continue;
    if (inTwo === 0) {
      accum = code << 4;
    } else {
      accum |= code;
      res[pos++] = accum;
    }
    inTwo = (inTwo + 1) % 2;
  }
  return res.subarray(0, pos);
}

function calcNumBytes(str) {
  return Math.floor(str.length / 2);
}

function encode(arr) {
  let s = '';
  for (let i = 0; i < arr.length; i++) {
    const code = arr[i];
    s += hexEncodeArray[code >>> 4];
    s += hexEncodeArray[code & 0x0F];
  }
  return s;
}

class PrivateKeyAuthenticationInfo extends AuthenticationInfo {




  constructor(clientId, privateKey) {
    super();
    this.clientId = clientId;
    this.privateKey = privateKey;
  }

  getClientId() {
    return this.clientId;
  }

  getUserKey() {return this.clientId;}

  getPrivateKey() {
    return this.privateKey;
  }

  async getAuthentication() {
    const token = await this.createBearerToken();
    const authentication = {
      token
    };
    return authentication;
  }

  async createBearerToken() {
    const format = 'jwk';
    const extractable = false;
    const algo = {
      name: 'RSASSA-PKCS1-v1_5',
      hash: { name: 'SHA-256' }
    };
    const jwtHeader = { alg: 'RS256' };
    const jwtHeaderJson = JSON.stringify(jwtHeader);
    const jwtHeaderJsonBytes = Utf8.decode(jwtHeaderJson);
    const jwtHeaderJsonBase64 = Base64.encodeUrlSafe(jwtHeaderJsonBytes);

    const nowSeconds = Math.floor(Date.now() / 1000);
    const claims = {
      iss: this.clientId,
      sub: this.clientId,
      //jti: this.generateJti(),
      iat: nowSeconds,
      exp: nowSeconds + 600
    };
    const claimsJson = JSON.stringify(claims);
    const claimsJsonBytes = Utf8.decode(claimsJson);
    const claimsJsonBase64 = Base64.encodeUrlSafe(claimsJsonBytes);

    const thingToBeSigned = Utf8.decode(jwtHeaderJsonBase64 + '.' + claimsJsonBase64);

    const resultKey = await webcrypto.subtle.importKey(format, this.privateKey, algo, extractable, ['sign']);
    const signature = await webcrypto.subtle.sign(algo.name, resultKey, thingToBeSigned);
    const sigAsString = Base64.encodeUrlSafe(new Uint8Array(signature));
    return jwtHeaderJsonBase64 + '.' + claimsJsonBase64 + '.' + sigAsString;
  }

  generateJti() {
    const bytes = webcrypto.getRandomValues(new Uint8Array(10));
    return Hex.encode(bytes);
  }
}

class TokenAuthenticationInfo extends AuthenticationInfo {




  constructor(clientId, token) {
    super();
    this.clientId = clientId;
    this.token = token;
  }

  getClientId() {
    return this.clientId;
  }

  getUserKey() {return this.clientId;}

  getToken() {
    return this.token;
  }

  async getAuthentication() {
    const authentication = {
      token: this.token
    };
    return authentication;
  }
}

class InDoipMessageSingleSegment {



  constructor(isJson, value) {
    this.segment = new InDoipSegment(isJson, value);
  }

  [Symbol.asyncIterator]() {
    return this;
  }

  async next() {
    if (this.done) return { done: true, value: undefined };
    this.done = true;
    return { done: false, value: this.segment };
  }

  async close() {
    if (!this.done) await this.segment.close();
    this.done = true;
  }
}

class DoipClientResponse {




  constructor(initialSegmentJson, inDoipMessage) {
    this.initialSegmentJson = initialSegmentJson;
    this.inDoipMessage = inDoipMessage;
  }

  getStatus() {
    return this.initialSegmentJson.status;
  }

  getAttributes() {
    return this.initialSegmentJson.attributes;
  }

  getAttribute(key) {
    return this.initialSegmentJson.attributes?.[key];
  }

  getOutput() {
    if (this.initialSegmentJson.output) {
      return new InDoipMessageSingleSegment(true, this.initialSegmentJson.output);
    } else {
      return this.inDoipMessage;
    }
  }

  async close() {
    if (this.inDoipMessage) {
      await this.inDoipMessage.return?.();
    }
  }
}

class InDoipMessageFromIterable {



  constructor(asyncIterable) {
    this.asyncIterator = asyncIterable[Symbol.asyncIterator]();
  }

  [Symbol.asyncIterator]() {
    return this;
  }

  async next() {
    if (this.done) return { done: true, value: undefined };
    return this.asyncIterator.next();
  }

  async close() {
    if (this.asyncIterator.return) await this.asyncIterator.return();
    this.done = true;
  }
}

class ServiceInfoProvider {

  static handleProxyBaseUri = "https://hdl.handle.net/api/handles/";

  static DOIP_SERVICE = "0.TYPE/DOIPService";
  static DOIP_SERVICE_INFO = "0.TYPE/DOIPServiceInfo";



  constructor(protocol) {
    this.protocol = protocol;
  }

  async getServiceInfoForHandle(targetHandle) {
    try {
      const targetHandleRecord = await this.getHandleRecordFromProxy(targetHandle);
      let doipServiceInfoHandleValue = this.getValueByType(targetHandleRecord, ServiceInfoProvider.DOIP_SERVICE_INFO);
      if (!doipServiceInfoHandleValue) {
        const doipServiceHandleValue = this.getValueByType(targetHandleRecord, ServiceInfoProvider.DOIP_SERVICE);
        if (!doipServiceHandleValue) return null;
        const doipServiceHandle = doipServiceHandleValue.data.value;
        const doipServiceHandleRecord = await this.getHandleRecordFromProxy(doipServiceHandle);
        doipServiceInfoHandleValue = this.getValueByType(doipServiceHandleRecord, ServiceInfoProvider.DOIP_SERVICE_INFO);
      }

      if (!doipServiceInfoHandleValue) return null;
      const doipServiceInfoJson = doipServiceInfoHandleValue.data.value;
      const doipServiceInfoParsed = JSON.parse(doipServiceInfoJson);
      const iface = this.getInterface(doipServiceInfoParsed, this.protocol);
      if (!iface) return null;
      const serviceInfo = this.buildServiceInfo(iface, doipServiceInfoParsed);
      return serviceInfo;
    } catch (e) {
      return null;
    }
  }

  async getHandleRecordFromProxy(handle) {
    const uri = ServiceInfoProvider.handleProxyBaseUri + HttpDoipClient.getEncodedWithSlashes(handle);
    const httpResponse = await fetch(uri);
    const statusCode = httpResponse.status;
    if (statusCode === 200) {
      const handleRecord = await httpResponse.json();
      return handleRecord;
    } else {
      throw new Error("Unable to retrieve handle from proxy:" + handle);
    }
  }

  buildServiceInfo(iface, doipServiceInfoJson) {
    const ipAddress = iface.ipAddress;
    const port = iface.port;
    let baseUri = "https://" + ipAddress + ":" + port;
    if (iface.path) {
      let path = iface.path;
      if (!path.startsWith("/")) {
        path = "/" + path;
      }
      baseUri = baseUri + path;
    }
    const serviceId = doipServiceInfoJson.id;
    const protocol = doipServiceInfoJson.attributes.protocol;
    const serviceInfo = {
      baseUri, ipAddress, port, serviceId, protocol
    };
    return serviceInfo;
  }

  getInterface(doipServiceInfoJson, protocol) {
    for (const iface of doipServiceInfoJson.attributes.interfaces) {
      const ifaceProtocol = iface.protocol;
      if (ifaceProtocol === protocol) {
        return iface;
      }
    }
    return null;
  }

  getValueByType(handleRecord, type) {
    for (const value of handleRecord.values) {
      if (type === value.type) {
        return value;
      }
    }
    return null;
  }
}

class InDoipMessageFromHttpResponse {





  constructor(response) {
    this.response = response;
    this.done = false;
    this.isJson = this.isJsonResponse();
  }

  isJsonResponse() {
    // TODO handle multipart responses
    const type = this.response.headers.get("Content-Type");
    if (!type) return false;
    if ("application/json" === type) return true;
    if (!type.startsWith("application/json")) return false;
    const nextChar = type.charAt("application/json".length);
    if (nextChar === ' ' || nextChar === '\t' || nextChar === ';') return true;
    return false;
  }

  async next() {
    if (this.done) return { done: true, value: undefined };
    this.done = true;
    let segment;
    if (this.isJson) {
      const jsonData = await this.response.json();
      segment = new InDoipSegment(true, jsonData);
    } else {
      segment = new InDoipSegment(false, this.response.body);
    }
    return {
      done: false,
      value: segment
    };
  }

  async close() {
    if (!this.done) await this.response.body?.cancel();
    this.done = true;
  }

  [Symbol.asyncIterator]() {
    return this;
  }
}

// Note: since streaming requests is only supported in certain browsers (late 2023) and only for HTTP/2, we use Blob exclusively
// // https://developer.chrome.com/articles/fetch-streaming-requests/
// const supportsRequestStreams = (() => {
//     let duplexAccessed = false;

//     const hasContentType = new Request('https://example.org', {
//         body: new ReadableStream(),
//         method: 'POST',
//         get duplex() {
//             duplexAccessed = true;
//             return 'half';
//         }
//     } as RequestInit).headers.has('Content-Type');

//     return duplexAccessed && !hasContentType;
// })();

class HttpDoipClient extends AbstractDoipClient {







  constructor(baseUriOrServiceInfo) {
    super();
    if (typeof baseUriOrServiceInfo === 'string') {
      this.defaultServiceInfo = this.synthesizeServiceInfoFromBaseUri(baseUriOrServiceInfo);
    } else if (baseUriOrServiceInfo) {
      // this.baseUri = this.baseUriFromServiceInfo(baseUriOrServiceInfo);
      this.defaultServiceInfo = baseUriOrServiceInfo;
    }
    this.serviceInfoProvider = new ServiceInfoProvider("HTTPS");
  }

  synthesizeServiceInfoFromBaseUri(baseUri) {
    return {
      baseUri
    };
  }

  getDefaultServiceInfo() {
    return this.defaultServiceInfo;
  }

  async getServiceInfoForRequest(doipRequest, serviceInfo) {
    if (serviceInfo) {
      return serviceInfo;
    }
    if (this.defaultServiceInfo) {
      return this.defaultServiceInfo;
    }
    const serviceInfoFromTargetId = await this.serviceInfoProvider.getServiceInfoForHandle(doipRequest.targetId);
    if (!serviceInfoFromTargetId) {
      throw new Error("No service for target:" + doipRequest.targetId + " could be found");
    }
    return serviceInfoFromTargetId;
  }

  async performOperation(doipRequest, serviceInfo, requestOptions) {
    const serviceInfoForRequest = await this.getServiceInfoForRequest(doipRequest, serviceInfo);
    const baseUriForRequest = this.baseUriFromServiceInfo(serviceInfoForRequest);
    const doipRequestHeaders = await this.headersFrom(doipRequest);
    const inDoipMessage = doipRequest.input;
    const doipResponse = await this.sendMultiPartRequest(doipRequestHeaders, inDoipMessage, baseUriForRequest, requestOptions);
    return doipResponse;
  }

  async sendMultiPartRequest(doipRequestHeaders, inDoipMessageRequest, baseUriForRequest, requestOptions) {
    const url = this.buildUriForHeaders(doipRequestHeaders, baseUriForRequest);
    const blobParts = [];
    const boundary = webcrypto.randomUUID();
    const headers = {
      "Content-Type": "multipart/mixed; boundary=" + boundary
    };
    if (doipRequestHeaders.authentication) {
      headers.Authorization = this.buildDoipAuthHeader(doipRequestHeaders.authentication);
    }
    let count = 0;
    for await (const segment of inDoipMessageRequest) {
      const defaultName = "part-" + count; //At time of writing server side code requires part names for multipart/mixed
      count++;
      const partContentType = segment.isJson ? "application/json" : "application/octet-stream";
      const boundaryHeaders = this.createBoundaryHeadersString(boundary, partContentType, defaultName);
      blobParts.push(boundaryHeaders);
      blobParts.push(await segment.blob());
    }
    const finalBoundary = this.createFinalBoundaryString(boundary);
    blobParts.push(finalBoundary);
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: new Blob(blobParts)
      });
      return this.buildDoipClientResponseForHttpResponse(response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  createBoundaryHeadersString(boundary, contentType, name) {
    let result = "\r\n--" + boundary + "\r\n";
    result += "Content-Disposition: form-data; name=" + name + "\r\n";
    result += "Content-Type: " + contentType + "\r\n\r\n";
    return result;
  }

  createFinalBoundaryString(boundary) {
    return "\r\n--" + boundary + "--\r\n\r\n";
  }

  async performCompactOperation(doipRequest, serviceInfo, requestOptions) {
    const serviceInfoForRequest = await this.getServiceInfoForRequest(doipRequest, serviceInfo);
    const baseUriForRequest = this.baseUriFromServiceInfo(serviceInfoForRequest);
    const doipRequestHeaders = await this.headersFrom(doipRequest);
    const doipResponse = await this.sendCompactRequest(doipRequestHeaders, baseUriForRequest, requestOptions);
    return doipResponse;
  }

  async sendCompactRequest(doipRequestHeaders, baseUriForRequest, requestOptions) {
    const httpRequest = {
      method: "POST",
      headers: {}
    };
    const url = this.buildUriForHeaders(doipRequestHeaders, baseUriForRequest);
    if (doipRequestHeaders.authentication) {
      this.addCredentials(httpRequest, doipRequestHeaders.authentication);
    }
    if (doipRequestHeaders.input) {
      httpRequest.headers = {
        "Content-Type": "application/json"
      };
      httpRequest.body = JSON.stringify(doipRequestHeaders.input);
    }
    if (doipRequestHeaders.authentication) {
      httpRequest.headers.Authorization = this.buildDoipAuthHeader(doipRequestHeaders.authentication);
    }
    try {
      const response = await fetch(url, httpRequest);
      return this.buildDoipClientResponseForHttpResponse(response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  buildDoipClientResponseForHttpResponse(response) {
    const initialSegmentJson = this.initialSegmentJsonFromHttpResponse(response);
    const inDoipMessage = new InDoipMessageFromHttpResponse(response);
    const doipClientResponse = new DoipClientResponse(initialSegmentJson, inDoipMessage);
    //TODO consider something like doipClientResponse.setOnClose(() -> HttpClientUtils.closeQuietly(httpResponse));
    // doipClientResponse.setCloseCallback(async () => {
    //     //await doipConnection.close();
    // });
    return doipClientResponse;
  }

  //Only used if the doip response header is missing
  static statusMap = new Map([
  [200, DoipConstants$1.STATUS_OK],
  [400, DoipConstants$1.STATUS_BAD_REQUEST],
  [401, DoipConstants$1.STATUS_UNAUTHENTICATED],
  [403, DoipConstants$1.STATUS_FORBIDDEN],
  [404, DoipConstants$1.STATUS_NOT_FOUND],
  [409, DoipConstants$1.STATUS_CONFLICT],
  [500, DoipConstants$1.STATUS_ERROR]]
  );

  initialSegmentJsonFromHttpResponse(response) {
    const doipResponseHeaderValue = response.headers.get("Doip-Response");
    if (doipResponseHeaderValue != null) {
      return JSON.parse(doipResponseHeaderValue);
    } else {
      const statusCode = response.status;
      const doipStatus = HttpDoipClient.statusMap.get(statusCode);
      return {
        status: doipStatus
      };
    }
  }

  buildUriForHeaders(headers, baseUriForRequest) {
    let uri = baseUriForRequest +
    "?operationId=" + HttpDoipClient.getEncodedWithSlashes(headers.operationId) +
    "&targetId=" + HttpDoipClient.getEncodedWithSlashes(headers.targetId);
    if (headers.attributes != null) {
      const attributesJson = JSON.stringify(headers.attributes);
      uri += "&attributes=" + HttpDoipClient.getEncodedWithSlashes(attributesJson);
    }
    return uri;
  }

  static getEncodedWithSlashes(toEncode) {
    return encodeURIComponent(toEncode).replace(/%2F/g, '/');
  }

  addCredentials(httpRequest, authentication) {
    this.addDoipAuthHeader(httpRequest.headers, authentication);
  }

  addDoipAuthHeader(headers, authentication) {
    headers.Authorization = this.buildDoipAuthHeader(authentication);
  }

  buildDoipAuthHeader(authentication) {
    const jsonString = JSON.stringify(authentication);
    const base64OfJson = Base64.encode(Utf8.decode(jsonString));
    return "Doip " + base64OfJson;
  }

  baseUriFromServiceInfo(serviceInfo) {
    if (serviceInfo.baseUri) return serviceInfo.baseUri;
    const baseUri = "https://" + serviceInfo.ipAddress + ":" + serviceInfo.port + "/doip/";
    return baseUri;
  }

  async shutdown() {

    //no-op
  }}

export { AbstractDoipClient, AuthenticationInfo, DigitalElementWithBody, DoipClientResponse, DoipConstants, DoipError, HttpDoipClient, InDoipMessageFromIterable as InDoipMessageFromAsyncIterable, InDoipMessageFromHttpResponse, InDoipMessageFromIterable$1 as InDoipMessageFromIterable, InDoipMessageSingleSegment as InDoipMessageSingleSegent, PasswordAuthenticationInfo, PrivateKeyAuthenticationInfo, TokenAuthenticationInfo };
//# sourceMappingURL=doip-client.js.map
